import './validators/extend_validations'

import React from 'react';
import * as FlexWebChat from "@twilio/flex-webchat-ui";

import ptBR from './locales/pt-BR.json'
import { SurveyForm, CustomMessageBubble, HideChat, CustomHeader } from './components';
import { inputVisibilitySubscriber } from './store/inputVisibilitySubscriber';

class App extends React.Component {
  state = {};
  
  constructor(props) {
    super(props);

    const context = {
      ...window.sdwtc_data
    }

    const { configuration } = props;

    FlexWebChat.Manager.create({ ...configuration, context })
      .then(manager => {
        // translates
        // https://www.twilio.com/docs/flex/developer/ui/localization-and-templating#current-default-values
        for (const field of Object.keys(ptBR)) {
          manager.strings[field] = ptBR[field];
        }
        this.setState({ manager })

        FlexWebChat.MessageCanvasTray.Content.replace(
          <SurveyForm
            key="survey-form"
            manager={manager}
          />
        )


        FlexWebChat.MessageBubble.Content.replace(
          <CustomMessageBubble
            key="custom-message-bubble"
            manager={manager}
          />
        )

        if (manager.store.getState().flex.session.isEntryPointExpanded && !window.sdwtc_data.open_widget) {
          FlexWebChat.Actions.invokeAction('ToggleChatVisibility')
        }


        FlexWebChat.MainHeader.Content.replace(
          <CustomHeader manager={manager} key="custom-header" />
        )

        let subscriberTimeoutId = null
        
        manager.store.subscribe(() => {
          if(subscriberTimeoutId) {
            clearTimeout(subscriberTimeoutId)
          }

          subscriberTimeoutId = setTimeout(() => {
            const state = manager.store.getState()

            inputVisibilitySubscriber(state)
          }, 100)
        })

      })
      .catch(error => this.setState({ error }));

    FlexWebChat.EntryPoint.defaultProps.tagline = 'Posso ajudar?';
    FlexWebChat.MainHeader.defaultProps.imageUrl = process.env.REACT_APP_URL + 'img/mobly-logo.png';
    FlexWebChat.MainHeader.defaultProps.showTitle = false;
    FlexWebChat.MessagingCanvas.defaultProps.showWelcomeMessage = false

    let body = `Olá! Aqui é o Deco, agente virtual da Mobly. Em que posso te ajudar?
    {button:Quero Comprar}
    {button:Meus Pedidos}
`

    FlexWebChat.MessagingCanvas.defaultProps.predefinedMessage = {
      body,
      authorName: 'Deco – Assistente Virtual da Mobly',
      isFromMe: false,
    }
    FlexWebChat.RootContainer.Content.add(
      <HideChat manager={this.state.manager} key="hide-chat" />
    )
  }

  render() {
    const { manager, error } = this.state;
    if (manager) {
      return (
        <FlexWebChat.ContextProvider manager={manager}>
          <FlexWebChat.RootContainer />
        </FlexWebChat.ContextProvider>
      );
    }

    if (error) {
      console.error("Failed to initialize Flex Web Chat", error);
    }

    return null;
  }
}

export default App;
